"use client";
import dynamic from "next/dynamic";

const LiveLecture1011CSR = dynamic(() => import("./index"), {
  ssr: false,
});

export default LiveLecture1011CSR;
